import { Badge } from "./ui/badge";
import { CheckCircle2, AlertTriangle, HelpCircle, MinusCircle, Search } from "lucide-react";

const MAP = {
    verified_from_source: {
        label: "Verified",
        icon: CheckCircle2,
        className: "bg-primary text-primary-foreground border-transparent",
    },
    inferred_from_listing: {
        label: "Inferred",
        icon: Search,
        className: "bg-muted text-foreground border-transparent",
    },
    ai_estimated: {
        label: "AI Estimated",
        icon: Search,
        className: "border border-accent/60 text-accent bg-transparent",
    },
    needs_local_verification: {
        label: "Needs Local Verification",
        icon: AlertTriangle,
        className: "bg-[hsl(35_90%_50%/0.15)] text-[hsl(35_90%_45%)] border-transparent",
    },
    conflicting_data: {
        label: "Conflicting",
        icon: AlertTriangle,
        className: "bg-destructive/15 text-destructive border-transparent",
    },
    not_available: {
        label: "Not Available",
        icon: MinusCircle,
        className: "bg-muted text-muted-foreground border-transparent",
    },
};

const ConfidenceBadge = ({ status, testid }) => {
    const meta = MAP[status] || {
        label: "Unknown",
        icon: HelpCircle,
        className: "bg-muted text-muted-foreground",
    };
    const Icon = meta.icon;
    return (
        <Badge
            data-testid={testid}
            className={`gap-1 font-medium uppercase tracking-wider text-[10px] py-0.5 ${meta.className}`}
        >
            <Icon className="w-3 h-3" />
            {meta.label}
        </Badge>
    );
};

export default ConfidenceBadge;
